export const locales = {
  fa: {
    key: "fa",
    name: "فارسی",
    englishName: "Persian",
    isRtl: true,
    startOfWeek: 6, // Saturday
  },
  en: {
    key: "en",
    name: "English",
    englishName: "English",
    isRtl: false,
    startOfWeek: 0, // Sunday
  },
  fr: {
    key: "fr",
    name: "Français",
    englishName: "French",
    isRtl: false,
    startOfWeek: 1, // Monday
  },
  de: {
    key: "de",
    name: "Deutsch",
    englishName: "German",
    isRtl: false,
    startOfWeek: 1, // Monday
  },
  es: {
    key: "es",
    name: "Español",
    englishName: "Spanish",
    isRtl: false,
    startOfWeek: 1, // Monday
  },
  it: {
    key: "it",
    name: "Italiano",
    englishName: "Italian",
    isRtl: false,
    startOfWeek: 1, // Monday
  },
  ar: {
    key: "ar",
    name: "العربية",
    englishName: "Arabic",
    isRtl: true,
    startOfWeek: 6, // Saturday
  },
};

export type Locale = keyof typeof locales;
